import {ErrorMessage} from '../../components/form/error-message.js'
import {FieldRoot} from '../../components/form/field-root.js'
import {useFieldContext} from '../../integrations/form/index.js'
import {Switch as ChakraSwitch, SwitchRootProps as ChakraSwitchProps, Field, TextProps} from '@chakra-ui/react'
import {HiCheck, HiX} from 'react-icons/hi'

interface Props extends ChakraSwitchProps {
  label: string
  hideLabel?: boolean
  description?: string
  descriptionProps?: TextProps
  isLabelOnLeft?: boolean
}

export function Switch({label, hideLabel, description, descriptionProps, isLabelOnLeft, ...props}: Props) {
  const field = useFieldContext<boolean>()

  return (
    <FieldRoot required={props.required} disabled={props.disabled}>
      <ChakraSwitch.Root
        name={field.name}
        checked={field.state.value}
        onCheckedChange={changes => field.handleChange(changes.checked)}
        onBlur={field.handleBlur}
        value={field.state.value ? 'on' : 'off'}
        display={'flex'}
        flexDirection={isLabelOnLeft ? 'row-reverse' : 'row'}
        {...props}
      >
        <ChakraSwitch.HiddenInput />
        <ChakraSwitch.Control>
          <ChakraSwitch.Thumb>
            <ChakraSwitch.ThumbIndicator fallback={<HiX color="black" />}>
              <HiCheck />
            </ChakraSwitch.ThumbIndicator>
          </ChakraSwitch.Thumb>
        </ChakraSwitch.Control>
        <Field.Label asChild>
          <ChakraSwitch.Label srOnly={hideLabel}>
            {label}
            <Field.RequiredIndicator />
          </ChakraSwitch.Label>
        </Field.Label>
      </ChakraSwitch.Root>
      {description && (
        <Field.HelperText mt={2} srOnly={description} {...descriptionProps}>
          {description}
        </Field.HelperText>
      )}
      <ErrorMessage />
    </FieldRoot>
  )
}
